module.exports = __webpack_public_path__ + "img/red_quotes.56177c62.svg";